'use strict';

var moment = require('moment');
var _ = require('lodash');

/**
 * List of durations and associated times that you can start at.
 *
 * @param {String} date YYYY-MM-DD
 * @param {Number} time Hmm
 * @return {moment} UTC-based moment representing this date/time
 */

exports.momentFromDateTime = function (date, time) {
  var str = date + ' ' + Math.floor(time / 100) + ':' + time % 100;
  return moment.utc(str, 'YYYY-MM-DD H:m');
};

/**
 * Get a list of `{ value: Number, display: String }` objects representing
 * every half-hour in the day. Convenient for plugging in to time selects
 * as `ng-options="time.value as time.display for time in times"`
 *
 * @return {Array}
 */

exports.getTimeSelectOptions = function (increment) {

  var step = increment || 30;
  var dt = new Date(1970, 0, 1, 6, 0, 0, 0);
  var rc = [];
  while (dt.getDate() === 1) {
    var display = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
    var value = dt.getHours() * 100 + dt.getMinutes();
    rc.push({ value: value, display: display });
    dt.setMinutes(dt.getMinutes() + step);
  }
  return rc;
};

/**
 * Get a list of `{ value: Number, display: String }` objects representing every half hour in duration increments
 *
 * @param {Number} num(optional), limit to num hours to go up to
 * @return {Array}
 */

exports.getDurationSelectOptions = function (num) {
  var durations = [];

  for (var i = 1; i <= (num || 12); i += 0.5) {
    var v = i * 60;
    var hourStr = i === 1 ? 'hour' : 'hours';

    durations.push({
      value: v,
      display: i + ' ' + hourStr
    });
  }

  return durations;
};

/**
  * Convert Number format to h:mm
  * For instance, 1330 => 1:30 p.m.
  @param {Integer} input
  @param {Boolean} amPm
*/

exports.integerToCivilianTime = function (input, amPm) {
  if (!_.isFinite(input)) {
    return undefined;
  }

  amPm = amPm || false;
  input = parseInt(input, 10);

  var minutes = input % 100;
  var hours = (input - minutes) / 100;
  var am_pm = hours >= 12 ? 'PM' : 'AM';

  var numDigitsToPad = 2;
  if (amPm) {
    var hoursToPad = hours % 12 || 12;
    if (hoursToPad < 10) numDigitsToPad = 1;
    return _.padStart(hoursToPad, numDigitsToPad, '0') + ':' + _.padStart(minutes, 2, '0') + ' ' + am_pm;
  }
  return _.padStart(hours, 2, '0') + ':' + _.padStart(minutes, 2, '0');
};

/**
 * Convert moment to time integer
 * @param {Moment}
 * @return {Number}
 */
exports.timeAsInteger = function (date) {
  var civilianDate = date.format('HH:mm');
  var splitDate = civilianDate.split(':');
  return parseInt(splitDate[0], 10) * 100 + parseInt(splitDate[1], 10);
};

/**
 * Convert duration to number that can be added to a time to get the end time
 * For instance, 120 => 230 (1130 + 230 => 1400)
 *
 * @param {Number}
 * @return {Number}
 */

exports.convertDurationToInteger = function (duration) {
  if (!duration) {
    return;
  }
  return Math.floor(duration / 60) * 100 + duration % 60;
};

exports.getDurationFromTimes = function (start, end) {
  var diff = parseInt(end, 10) - parseInt(start, 10);
  var hours = Math.floor(diff / 100) * 60;
  var minutes = diff % 100 >= 60 ? diff % 100 - 40 : diff % 100;
  return hours + minutes;
};

exports.getEndTimeFromStartTimeAndDuration = function (startTime, duration) {
  var time = startTime + exports.convertDurationToInteger(duration);
  // handle cases like 1260
  return Math.floor(time % 100 / 60) === 1 ? time - 60 + 100 : time;
};